module.exports = __webpack_public_path__ + "static/assets/f48c11eb9c605735490ac13a0660803b.png";